module.exports = __webpack_public_path__ + "media/images/ui__infoOk--dark-2414cf041480391b45dccfa9cb2e496e.png";